import { StateType } from '../types/StateType';

export default {
  loading: false,
} as StateType;
